<template>
  <div>
    <div v-bind:class="pageClass" :key="index" v-for="(item, index) in arr">
      <div :class="[calculateTransition(index), 'subPage']">
        <div class="sticker design-5">
          <div class="top-section">
            <div class="left-column">
              <div class="rewards-logo">
                <img src="/img/icons/msr_logo.png" alt="MSR Logo" width="84" height="42" />
              </div>
              <div v-if="item.showDiscountPrice" class="member-price-label">MEMBER<br />PRICE</div>
              <div v-if="item.showDiscountPrice" class="member-price-value">
                <span v-if="item.memberShowRupee" class="rupee-symbol-2">₹</span>{{ item.memberDisplay }}
              </div>
            </div>
            <div class="right-column">
              <div v-if="item.showDiscountPrice" class="non-member-price-label">NON<br />MEMBER<br />PRICE</div>
              <div v-if="item.showDiscountPrice" class="non-member-price-value">
                <span v-if="item.nonMemberShowRupee" class="rupee-symbol-2">₹</span>{{ item.nonMemberDisplay }}
              </div>
            </div>
          </div>
          <div class="middle-section">
            <div v-if="item.showProductName" class="product-name">{{ item.productName }}</div>
            <div v-if="item.showMrp" class="mrp-text">
              MRP
              <span class="rupee-symbol-small">₹</span>{{ formatValue(item.mrp) }}
            </div>
          </div>
          <div class="bottom-section">
            <div class="savings-message"
              ><span class="plus-symbol">+</span>SAVE UPTO 6% EXTRA MONTHLY | ₹600/MONTH WITH
              <span class="bottom-msr-logo">
                <img src="/img/icons/msr_logo.png" alt="MSR Logo" width="60" height="20" />
              </span>
            </div>
          </div>
        </div>
        <div class="validTo">(ValidTo:{{ item.validTo }})</div>
        <div class="footer-date"> (PPD:{{ currentDate() }}) </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * POP Manual Form Box MSR print – A7.
 * Non-member: percentage field → "X% off"; rupee off → "₹ X off".
 * Member: MSR field → numeric with ₹ or offer text (e.g. "X% off", "₹ X off").
 */
export default {
  name: 'PromoTemplateA7MsrManual',
  props: {
    data: Array
  },
  computed: {
    pageClass() {
      return this.data && this.data.length > 1 ? 'page' : 'page-without-break';
    }
  },
  data() {
    return {
      arr: []
    };
  },
  watch: {
    data(newValue) {
      if (newValue !== null && newValue !== undefined) {
        const flat = Array.isArray(newValue[0]) ? newValue.flat() : newValue;
        this.arr = flat.map(item => this.mapManualMsrItem(item));
      }
    }
  },
  methods: {
    mapManualMsrItem(item) {
      const productName = item.articleDescription || '';
      const percentageOff = item.percentageOff != null && item.percentageOff !== '' ? Number(item.percentageOff) : NaN;
      const rupeesOff = item.rupeesOff != null && item.rupeesOff !== '' ? Number(item.rupeesOff) : NaN;
      const hasPercentage = !isNaN(percentageOff) && percentageOff > 0;
      const hasRupeeOff = !isNaN(rupeesOff) && rupeesOff > 0;

      // Non-member: use percentage field → "X% off"; rupee off → "₹ X off"
      let nonMemberDisplay = '';
      let nonMemberShowRupee = false;
      if (item.nonMemberOfferLabel) {
        nonMemberDisplay = item.nonMemberOfferLabel;
        if (!nonMemberDisplay.includes('₹') && !nonMemberDisplay.includes('%')) {
          nonMemberShowRupee = !Number.isNaN(Number(String(nonMemberDisplay).replace(/,/g, '')));
        }
      } else if (hasPercentage) {
        nonMemberDisplay = Number.isInteger(percentageOff)
          ? `${percentageOff}% off`
          : `${percentageOff.toFixed(2)}% off`;
      } else if (hasRupeeOff) {
        nonMemberShowRupee = true;
        nonMemberDisplay = Number.isInteger(rupeesOff) ? `${rupeesOff} off` : `${rupeesOff.toFixed(2)} off`;
      } else if (item.offerPrice != null && item.offerPrice !== '') {
        nonMemberShowRupee = true;
        nonMemberDisplay = String(item.offerPrice);
      }

      // Member: use MSR field (memberPrice)
      const memberPrice = item.memberPrice;
      let memberDisplay = '';
      let memberShowRupee = false;
      if (item.memberOfferLabel) {
        memberDisplay = item.memberOfferLabel;
        if (!memberDisplay.includes('₹') && !memberDisplay.includes('%')) {
          memberShowRupee = !Number.isNaN(Number(String(memberDisplay).replace(/,/g, '')));
        }
      } else if (memberPrice != null && memberPrice !== '') {
        const num = Number(memberPrice);
        if (!Number.isNaN(num)) {
          memberDisplay = Number.isInteger(num) ? String(num) : num.toFixed(2);
          memberShowRupee = true;
        } else {
          memberDisplay = String(memberPrice);
        }
      }

      // Rupee symbol only when string has neither ₹ nor %
      if (nonMemberDisplay && (nonMemberDisplay.includes('₹') || nonMemberDisplay.includes('%'))) {
        nonMemberShowRupee = false;
      }
      if (memberDisplay && (memberDisplay.includes('₹') || memberDisplay.includes('%'))) {
        memberShowRupee = false;
      }

      return {
        productName,
        mrp: item.mrp,
        nonMemberDisplay,
        nonMemberShowRupee,
        memberDisplay,
        memberShowRupee,
        showProductName: true,
        showMrp: true,
        showDiscountPrice: true,
        validTo: item.validTo
      };
    },
    formatValue(value) {
      if (value === null || value === undefined) return '';
      return String(value);
    },
    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
      return date;
    },
    calculateTransition(index) {
      const transitions = [
        'transition1',
        'transition2',
        'transition3',
        'transition4',
        'transition5',
        'transition6',
        'transition7',
        'transition8'
      ];
      return transitions[index % 8] || '';
    }
  }
};
</script>
